import ImigrationReportIndex from "@/views/report/imigration/ImigrationReportIndex.vue";
import ImigrationReportPrint from "@/views/report/imigration/ImigrationReportPrint.vue";

const imigrationReport = [
  {
    path: "/imigration-report",
    name: "imigration-report",
    component: ImigrationReportIndex,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","supervisor"],
      public: false,
    },
  },
  {
      path: "/imigration-report/print",
      name: "imigration-report-print",
      component: ImigrationReportPrint,
      meta: {
        layout: "print",
        role: ["superadmin","backoffice","supervisor"],
        public: false,
      },
    },
];

export default imigrationReport;
